// /assets/water-advisories/water-advisories.js
import { wireZipForm, wireStateSelect, wireMap, initWorldWaterNews } from "./water-advisories-dom.js";

export function initWaterAdvisories(root = document) {
  wireZipForm(root);
  wireStateSelect(root);
  wireMap(root);
  initWorldWaterNews(); // Initialize world news if applicable
}

// Auto-init on DOM ready if desired:
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => initWaterAdvisories());
} else {
  initWaterAdvisories();
}
